export const addItem = (itemToAdd) => {
  return {
    type: "cart/addItem",
    payload: itemToAdd,
  };
};

export const changeItemQuantity = (name, newQuantity) => {
  return {
    type: "cart/changeItemQuantity",
    payload: { name, newQuantity },
  };
};

export const removeItem = (name) => {
  return {
    type: "cart/removeItem",
    payload: name,
  };
};

const initialCart = {};
export const cartReducer = (cart = initialCart, action) => {
  switch (action.type) {
    case "cart/addItem": {
      const { name, price } = action.payload;

      // if the item already exists, increase the quantity by 1, otherwise set it to 1
      const quantity = cart[name] ? cart[name].quantity + 1 : 1;
      const newItem = { price, quantity };

      // Add the new item to the cart (or replace it if it existed already)
      return {
        ...cart,
        [name]: newItem,
      };
    }
    case "cart/changeItemQuantity": {
      const { name, newQuantity } = action.payload;

      if (!cart[name]) {
        return cart;
      }

      if (newQuantity <= 0) {
        const updatedCart = { ...cart };
        delete updatedCart[name];
        return updatedCart;
      }

      return { ...cart, [name]: { ...cart[name], quantity: newQuantity } };
    }
    case "cart/removeItem": {
      const itemName = action.payload;

      if (!cart[itemName]) {
        return cart;
      }

      const updatedCart = { ...cart };
      delete updatedCart[itemName];
      return updatedCart;
    }
    default: {
      return cart;
    }
  }
};
